export const environment = {
  production: false,
  caretakerUrl: 'https://caretaker.dev.service.75f.io/api/v1',
  remoteAccessServiceUrl: 'https://remote-access.dev.service.75f.io/api',
  siloUrl: 'https://silo.dev.service.75f.io/v2',
};
